// extracted by mini-css-extract-plugin
module.exports = {"container":"MainWrapper_container__2K9-d","spinner":"MainWrapper_spinner__tUJNn","shake-horizontal":"MainWrapper_shake-horizontal__2YJxe","grow":"MainWrapper_grow__3jUy_"};